import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const MEASUREMENT_ID = process.env.REACT_APP_GA_MEASUREMENT_ID || '';

const ensureAnalytics = () => {
  if (!MEASUREMENT_ID || typeof window === 'undefined' || typeof document === 'undefined') {
    return false;
  }

  if (!window.dataLayer) {
    window.dataLayer = [];
  }

  if (!window.gtag) {
    window.gtag = function gtag() {
      window.dataLayer.push(arguments);
    };
  }

  if (!document.querySelector(`script[data-ga-id="${MEASUREMENT_ID}"]`)) {
    const script = document.createElement('script');
    script.async = true;
    script.src = `https://www.googletagmanager.com/gtag/js?id=${MEASUREMENT_ID}`;
    script.dataset.gaId = MEASUREMENT_ID;
    document.head.appendChild(script);
  }

  return true;
};

const GoogleAnalytics = () => {
  const location = useLocation();

  useEffect(() => {
    if (!ensureAnalytics()) {
      return;
    }

    window.gtag('js', new Date());
    window.gtag('config', MEASUREMENT_ID, {
      send_page_view: false,
      anonymize_ip: true,
    });
  }, []);

  useEffect(() => {
    if (!MEASUREMENT_ID || typeof window === 'undefined' || typeof window.gtag !== 'function') {
      return;
    }

    window.gtag('event', 'page_view', {
      page_title: document.title,
      page_location: window.location.href,
      page_path: `${location.pathname}${location.search}`,
    });
  }, [location]);

  return null;
};

export default GoogleAnalytics;